import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"

export default function SuggestionApp() {
  const [suggestion, setSuggestion] = useState("")
  const [submissions, setSubmissions] = useState([])
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")

  useEffect(() => {
    fetchMySubmissions()
  }, [])

  const fetchMySubmissions = () => {
    fetch("/api/my_suggestions")
      .then(res => res.json())
      .then(data => setSubmissions(data))
      .catch(err => console.error("Error fetching submissions:", err))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!suggestion.trim()) return

    setLoading(true)
    setMessage("")

    try {
      const response = await fetch("/api/suggestions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({ suggestion: { content: suggestion } })
      })

      if (response.ok) {
        setMessage("Suggestion submitted successfully!")
        setSuggestion("")
        fetchMySubmissions()
      } else {
        setMessage("Error submitting suggestion. Please try again.")
      }
    } catch (err) {
      console.error("Error:", err)
      setMessage("Error submitting suggestion. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-50 to-purple-50 p-8">
      <div className="max-w-2xl mx-auto">
        <Link
          to="/"
          className="inline-block mb-6 text-cyan-600 hover:text-cyan-700 font-semibold"
        >
          ← Back to Home
        </Link>

        <div className="bg-white rounded-lg shadow-xl p-8 mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-6 text-center">
            Submit Your Suggestion
          </h1>

          <form onSubmit={handleSubmit} className="space-y-4">
            <textarea
              value={suggestion}
              onChange={(e) => setSuggestion(e.target.value)}
              placeholder="What would you like to see in the show?"
              className="w-full h-32 p-4 border-2 border-gray-300 rounded-lg focus:border-cyan-400 focus:outline-none resize-none"
              disabled={loading}
            />

            <button
              type="submit"
              disabled={loading || !suggestion.trim()}
              className="w-full bg-cyan-400 hover:bg-cyan-500 text-black font-bold text-lg py-3 rounded-lg transition-colors duration-200 disabled:bg-gray-300 disabled:cursor-not-allowed shadow-lg"
            >
              {loading ? "Submitting..." : "Submit Suggestion"}
            </button>
          </form>

          {message && (
            <p className={`mt-4 text-center font-semibold ${
              message.includes("success") ? "text-green-600" : "text-red-600"
            }`}>
              {message}
            </p>
          )}
        </div>

        {submissions.length > 0 && (
          <div className="bg-white rounded-lg shadow-xl p-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Your Submissions
            </h2>
            <ul className="space-y-3">
              {submissions.map((sub, index) => (
                <li key={index} className="p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <p className="text-gray-700">{sub.content}</p>
                  <p className="text-sm text-gray-500 mt-2">
                    {new Date(sub.created_at).toLocaleString()}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}
